import { publicAssetUrl } from "@/common/urls";

const data = {
    // 백조일손지지, 섯알오름
    1: {
        imgSrc: publicAssetUrl("img/seodal.jpg")
    },
    // 곤을동 잃어버린 마을
    2: {
        imgSrc: publicAssetUrl("img/gon.jpg")
    },
    // 주정공장 옛터
    3: {
        imgSrc: publicAssetUrl("img/jujeong.jpg")
    },
    // 북촌 너븐숭이
    4: {
        imgSrc: publicAssetUrl("img/noven.jpg")
    },
    // 낙선동 43성
    5: {
        imgSrc: publicAssetUrl("img/naksun.jpeg")
    },
    // 다랑쉬굴
    6: {
        imgSrc: publicAssetUrl("img/darang.jpg")
    },
    7: {
        imgSrc: publicAssetUrl("img/memorial.jpeg")
    },
    8: {
        imgSrc: publicAssetUrl("img/keunneolgwe.jpg")
    }
}

export default data;
